<template>
  <div class="post__video__wrapper">
    <div class="post__video">
      <div class="post__video__left">
        <div id="pin">
          <TestvVideoPlayer
            v-if="videoData"
            class="comp__TestvVideoPlayer"
            :video="videoData"
            @play="onPlay"
            @fullscreenchange="onFullscreenchange"
          />
          <TestvPostDate
            class="comp__TestvPostDate"
            :date="post.released_time"
            :category="post.title_prefix"
          />
        </div>
      </div>
      <div class="post__video__right">
        <div class="post__info__wrapper">
          <div class="post__title">{{ post.title }}</div>
          <div class="post__date">{{ post.released_time * 1000 | friendlyTime }}</div>
        </div>

        <PostComment
          class="comp__PostComment"
          ref="comments"
          :articleInfo="post"
          articleType="paid"
          :comments="comments"
        />

        <SSLoading
          :loading="loading"
          :loadEnd="loadEnd"
          :noDataAvailable="!comments.length"
          noDataAvailableText="暂无数据"
          loadEndText="没有更多数据了"
        />
      </div>
    </div>
  </div>
</template>

<script>
import postMixin from '../post-mixin.js'
import TestvVideoPlayer from '@/components/TestvVideoPlayer/index.vue'
import TestvPostDate from '@/components/TestvPostDate/index.vue'
import PostComment from '../_components/PostComment/index.vue'
import ScrollMagic from 'scrollmagic'
import debounce from 'lodash/debounce'

export default {
  name: 'PostVideo',

  mixins: [postMixin],

  components: {
    TestvVideoPlayer,
    TestvPostDate,
    PostComment
  },

  data () {
    return {
      controller: null,
      scene: null
    }
  },

  computed: {
    videoData () {
      if (!this.post) return null
      return {
        url: this.post.video_code,
        // url: 'https://cdnfile.sspai.com/video/20230628_shanjilihe.mp4',
        // url: 'https://cdnfile.sspai.com/video/20221116-team-guide.mp4',
        pic: this.$imageUrl(this.post.banner)
      }
    },
  },

  watch: {
  },

  methods: {
    resize: debounce(function () {
      this.scene.removePin(true)
      document.querySelector('.post__video__left').style.width = ``
      if (window.innerWidth >= 768) {
        const video = document.querySelector('#pin video')
        const { width } = video.getBoundingClientRect()
        document.querySelector('.post__video__left').style.width = `${width}px`
        this.scene.setPin('#pin')
      }
    }, 100),
    onPlay () {
      this.resize()
    },
    onFullscreenchange () {
      console.log('onFullscreenchange')
    }
  },

  async mounted () {
    this.controller = new ScrollMagic.Controller()
    this.scene = new ScrollMagic.Scene({
      triggerElement: '#pin',
      triggerHook: 92 / window.innerHeight
    })
    this.scene.addTo(this.controller)
    window.addEventListener('resize', this.resize)
  },

  destroyed () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/variable.styl';

.post__video {
  min-height: calc(var(--vh, 1vh) * 100 - var(--h-header) - env(safe-area-inset-bottom, 0px) - var(--gap, 0px));
  @media (min-width: $screen-md) {
    display: flex;
    justify-content: center;
    column-gap: 16px;
    margin: auto;
    padding: 32px 24px;
    .post__video__left {
      position: relative;
    }
    .post__video__right {
      flex: 1;
      min-width: 300px;
      max-width: 400px;
    }
  }
  @media (min-width: $screen-default) {
    column-gap: 24px;
    --gap: 64px;
  }
}

.comp__TestvVideoPlayer {
  @media (min-width: $screen-md) {
    border-radius: 4px;
    overflow: hidden;
    --gap: 64px;
  }
  >>>:not(.vjs-fullscreen) video {
    max-height: calc(var(--vh, 1vh) * 100 - var(--h-header) - env(safe-area-inset-bottom, 0px) - var(--gap, 0px));
    @media (min-width: $screen-md) {
      border-radius: 4px;
      min-width: 402px;
      max-width: 800px;
    }
  }
}

.comp__TestvPostDate {
  display: none;
  max-height: calc(var(--vh, 1vh) * 100 - var(--h-header) - env(safe-area-inset-bottom, 0px) - var(--gap, 0px));
  @media (min-width: $screen-default) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: absolute;
    left: -60px;
    top: 0px;
    transform: translateX(-100%);
    color: var(--dark-bwb-3);
    --size-TestvPostDateText--md: 112px;
    --size-TestvPostDateIcon--md: 96px;
  }
}

.post__info__wrapper {
  padding: 24px;
  padding-bottom: 38px;
  border-bottom: 1px solid var(--dark-bwb-3);
  color: var(--dark-bwb-7);
  margin-bottom: 32px;
  @media (min-width: $screen-md) {
    border: none;
    padding: 0;
    margin-bottom: 24px;
  }
  .post__title {
    font-size: 17px;
    @media (min-width: $screen-md) {
      font-size: 15px;
    }
  }
  .post__date {
    font-family: ui-monospace, 'SF Mono', monospace;
    font-size: 13px;
    font-weight: 500;
    margin-top: 8px;
    @media (min-width: $screen-default) {
      display: none;
    }
  }
}

#pin {
  inset: auto!important;
}
</style>
